import Button from '@mui/material/Button';
import { FormattedMessage } from 'react-intl';
import { PATHS } from '../../config/consts';
import { TId } from '../../modules/commonTypes';
import Alert from '../Alert';
import ButtonLink from '../ButtonLink';
import messages from './messages';

interface ISecurityCodeAlert {
  companyId: TId;
  detail?: boolean;
  devices: Array<{ name: string }>;
  onButtonClick?: (item: { name: string }) => void;
  siteId: TId;
}

const SecurityCodeAlert = ({
  companyId,
  detail = false,
  devices,
  onButtonClick = undefined,
  siteId,
}: ISecurityCodeAlert) => {
  const buttonTypography = (
    <>
      {devices.length === 1 && <FormattedMessage {...messages.securityCodeAlertButtonOneDevice} />}
      {devices.length > 1 && <FormattedMessage {...messages.securityCodeAlertButtonMoreDevices} />}
    </>
  );

  return (
    <Alert
      data-testid="devices-security-code-alert"
      action={
        onButtonClick ? (
          <Button data-testid="devices-verify-button" onClick={() => onButtonClick(devices[0])} size="small">
            {buttonTypography}
          </Button>
        ) : (
          <ButtonLink
            size="small"
            to={PATHS.NOT_VERIFIED_DEVICES.replace(':companyId', companyId.toString()).replace(
              ':siteId',
              siteId.toString()
            )}
          >
            {buttonTypography}
          </ButtonLink>
        )
      }
      severity="error"
    >
      {devices.length === 1 && !detail && (
        <FormattedMessage
          {...messages.securityCodeAlertListText}
          values={{
            deviceName: devices[0].name,
            strong: (chunks) => <strong>{chunks}</strong>,
          }}
        />
      )}
      {devices.length === 1 && detail && <FormattedMessage {...messages.securityCodeAlertDetailText} />}
      {devices.length > 1 && (
        <FormattedMessage
          {...messages.securityCodeAlertMoreDevicesText}
          values={{
            count: devices.length,
            devices: devices.map((item) => item.name).join(', '),
          }}
        />
      )}
    </Alert>
  );
};

export default SecurityCodeAlert;
